module.exports = ".main-column{\n  background-color:lavender;\n  border-radius: 20px;\n  margin: 10px;\n}\n\n.hide {\n  display: none;\n}\n\n.selected {\n  background-color: red;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/main.component.css
// module id = ./src/app/main/main.component.css
// module chunks = main